// extracted by mini-css-extract-plugin
var _1 = "TrainerGeneral__blockButton--Uezti";
var _2 = "TrainerGeneral__blueButtons--klXig";
var _3 = "TrainerGeneral__construction--OV2Q5";
var _4 = "TrainerGeneral__engineArea--r5EwO CoreGeneral__engineArea--z_i7G";
var _5 = "TrainerGeneral__engineBg--pzNDN CoreGeneral__engineBg--j2tiG";
var _6 = "TrainerGeneral__engineOuter--vJslo CoreGeneral__engineOuter--jw7Df";
var _7 = "TrainerGeneral__navButtons--OEZqV";
var _8 = "TrainerGeneral__pageBG--e3daW CoreGeneral__pageBG--w94xk";
var _9 = "TrainerGeneral__pageContainer--QZpaB CoreGeneral__pageContainer--xTHqq";
var _a = "TrainerGeneral__pageTop--SHztC CoreGeneral__pageTop--fP1Xg CoreGeneral__pageTopBase--WVn7b";
var _b = "TrainerGeneral__problemEngine--X7PVg CoreGeneral__problemEngine--u9RpX";
var _c = "TrainerGeneral__roboto--jwaDZ CoreGeneral__roboto--UlmjE";
var _d = "TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _e = "TrainerGeneral__robotoSlabMedium--zxA53 CoreGeneral__robotoSlabMedium--f2t8p";
var _f = "TrainerGeneral__star--osLBD";
var _10 = "TrainerGeneral__starContainer--b9GAH";
var _11 = "TrainerGeneral__starContainer0--sDZ3v TrainerGeneral__starContainer--b9GAH";
var _12 = "TrainerGeneral__starProgress--bSkTx";
export { _1 as "blockButton", _2 as "blueButtons", _3 as "construction", _4 as "engineArea", _5 as "engineBg", _6 as "engineOuter", _7 as "navButtons", _8 as "pageBG", _9 as "pageContainer", _a as "pageTop", _b as "problemEngine", _c as "roboto", _d as "robotoSlab", _e as "robotoSlabMedium", _f as "star", _10 as "starContainer", _11 as "starContainer0", _12 as "starProgress" }
